webpackJsonp([197937838038338],{

/***/ 1754:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DetailedCreditItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"DetailedCreditItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-detailed-credit-item-edge-3908cc072613566cc159.js